import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { FormattedDate } from 'components/intl'
import { compose } from 'recompose'
import { Modal, DuplicityInfo } from 'containers/misc'
import { ContactRemove } from 'containers/forms/contacts'
import { Table, Data } from 'components/layout/Table'
import { Button, BadgesLevels, RowSelectorTd } from 'components/misc'
import { TasksAssignLeaderOffline } from 'containers/forms/tasks'
import { tasks as tasksLayout } from 'constants/layout'
import { meta, permissions, tableCommon } from 'helpers/decorators'
import {
  apiUnassignedParticipants,
  apiAwards,
  apiParticipants,
  apiCodeLists,
  apiOrganizations
} from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'
import { BulkAwardLeaderAssignments } from 'containers/bulkChange'
import config from 'config'
import { REMOVE_CONTACT_TYPES, ROLES } from '../../../constants/enums'


const enhance = compose(
  meta({
    title: 'Tasks - Unassigned participants',
    intlKey: 'pageTitle.tasks_unassigned_participants'
  }),
  apiOrganizations({
    leaders: true,
    disableLimit: true,
    excludeInactive: true
  }),
  permissions(),
  apiUnassignedParticipants({
    list: true,
    useCommonLimit: true
  }),
  apiAwards({
    updateUnassignedTasks: true
  }),
  apiParticipants({
    updateTasks: true
  }),
  apiCodeLists(['participantReasonsOfDeletionTypes']),
  tableCommon(),
  connect(
    null,
    { modal }
  )
)

class TasksUnassignedParticipants extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    organizations: PropTypes.object.isRequired,
    codeLists: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    deleteParticipantRegistration: PropTypes.func.isRequired,
    assignLeader: PropTypes.func.isRequired,
    setUnassignedParticipantsParams: PropTypes.func,
    selectableAwardIds: PropTypes.array,
    setAwardsSelectedTo: PropTypes.func.isRequired,
    areAllAwardsSelected: PropTypes.bool,
    bulkSelectAwards: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func,
    permissions: PropTypes.object.isRequired
  }

  state = {
    participantDeleteId: null,
    participantRegistrationId: null
  }

  handleParticipantDelete = (
    participantDeleteId,
    participantRegistrationId
  ) => {
    this.setState(
      {
        participantDeleteId,
        participantRegistrationId
      },
      () => {
        this.props.modal('delete-unassigned-participant')
      }
    )
  }

  render() {
    const {
      tasks: { loading, list, limit, offset, pages, sort, selectedIds },
      selectableAwardIds: selectableIds,
      setUnassignedParticipantsParams,
      assignLeader,
      codeLists,
      areAllAwardsSelected,
      bulkSelectAwards,
      setAwardsSelectedTo,
      setCommonLimit,
      permissions: appPermission
    } = this.props
    const { participantRegistrationId, participantDeleteId } = this.state

    const safeSelectedIds = selectedIds || []

    const isGlobalRole = appPermission.activeRole === ROLES.GBT.u || appPermission.activeRole === ROLES.NAO_STAFF.u
        || appPermission.activeRole === ROLES.GOP_STAFF.u || appPermission.activeRole === ROLES.OA.u || appPermission.activeRole === ROLES.SOA.u

    return (
      <div>
        {!isGlobalRole && <BulkAwardLeaderAssignments
          selectedIds={safeSelectedIds}
          leaders={get(this.props, 'organizations.leaders', [])}
        />}

        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={isGlobalRole ? tasksLayout.unassignedParticipantsGBTHeader : tasksLayout.unassignedParticipantsHeader}
          areAllSelected={areAllAwardsSelected ? true : undefined}
          bulkSelect={() => bulkSelectAwards(safeSelectedIds, selectableIds)}
          setParams={setUnassignedParticipantsParams}
          dataTestId="unassignedParticipantTable"
        >
          <Data>
            {list.map(({ id, participantPerson, organization, award, date, duplicityInfo }) => (
              <tr key={id}>
                <RowSelectorTd
                  enabled={selectableIds && selectableIds.includes(
                    get(award, 'id')) ? true : undefined}
                  selected={selectedIds && selectedIds.includes(
                    get(award, 'id')) ? true : undefined}
                  setSelected={val => setAwardsSelectedTo(
                    get(award, 'id'), val)}
                />
                <td>
                  <Link to={`${config.publicPath}/participants/${get(participantPerson, 'id')}`}>
                    {get(participantPerson, 'globalId')}
                  </Link>
                </td>
                <td>{get(participantPerson, 'firstName')}</td>
                <td>{get(participantPerson, 'lastName')}</td>
                <td>{date && <FormattedDate value={date} />}</td>
                <td>
                  <BadgesLevels levels={[award]} participantId={get(award, 'participant.id')} single />
                </td>
                <td>{get(participantPerson, 'email')}</td>
                {isGlobalRole && <td>{get(organization, 'name')}</td>}
                <td>
                  <Button
                    onClick={() =>
                      this.handleParticipantDelete(
                        get(participantPerson, 'id'),
                        get(award, 'participantRegistration.id')
                      )
                    }
                    tiny
                    intlKey="button.delete"
                    dataTestId="deleteRegistrationButton"
                    secondary
                  >
                    Delete
                  </Button>
                </td>
                <td>
                  <div style={{ float: 'left' }}>
                    <TasksAssignLeaderOffline
                      assignLeader={assignLeader}
                      id={get(award, 'id')}
                      form={`leaderAssigmentForm-${get(award, 'id')}`}
                      organizations={this.props.organizations}
                      orgId={get(award, 'organization.id')}
                      decoOrganizationId={isGlobalRole ? get(award, 'organization.id') : null}
                      isGlobalRole={isGlobalRole}
                    />
                  </div>
                  <br />
                  {duplicityInfo && <DuplicityInfo data={duplicityInfo} />}
                </td>
              </tr>
            ))}
          </Data>
        </Table>
        <Modal id="delete-unassigned-participant" customActions enableOverflow>
          <ContactRemove
            id={participantDeleteId}
            onClose={this.handleDialogClose}
            onDelete={(...params) =>
              this.props.deleteParticipantRegistration(...params, {
                participantRegistrationId
              })
            }
            reasonsList={codeLists.participantReasonsOfDeletionTypes.list}
            contactRemoveType={REMOVE_CONTACT_TYPES.PARTICIPANT_REGISTRATION.value}
          />
        </Modal>
      </div>
    )
  }
}

export default enhance(TasksUnassignedParticipants)
